import type { RouteState } from "./router-model";

/** Fill for an active crosspoint / routed source, by route state. */
export const ROUTE_STATE_FILL: Record<RouteState, string> = {
  ok: "bg-primary border-primary text-primary-foreground",
  pending: "bg-amber-500 border-amber-500 text-white animate-pulse",
  error: "bg-destructive border-destructive text-destructive-foreground",
  unresolved: "bg-muted border-dashed border-muted-foreground/60",
};

/** Small status dot, by route state (ok has no dot). */
export const ROUTE_STATE_DOT: Record<RouteState, string | null> = {
  ok: null,
  pending: "bg-amber-500 animate-pulse",
  error: "bg-destructive",
  unresolved: "border border-dashed border-muted-foreground",
};

export const ROUTE_STATE_LABEL: Record<RouteState, string> = {
  ok: "Routed",
  pending: "Pending",
  error: "Error",
  unresolved: "Unresolved",
};
